// extracted by mini-css-extract-plugin
export default {"Heading":"progress-configuration-view-module__Heading--HATzy","Box":"progress-configuration-view-module__Box--ibTw8","Box_1":"progress-configuration-view-module__Box_1--x8vQ1"};